var map = {
	"./screen-app-settings.jpg": "d602",
	"./screen-backup-restore.jpg": "1efe",
	"./screen-bubble-options.jpg": "b5de",
	"./screen-chat-options.jpg": "1fa3",
	"./screen-clear-temp-files.jpg": "f5bf",
	"./screen-hero-collage.jpg": "12dd",
	"./screen-home-options.jpg": "b550",
	"./screen-privacy-security.jpg": "7862"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "100e";